// for custom networks visit -> https://docs.reown.com/appkit/react/core/custom-networks
import { Button } from "@/atoms-react/button/Button.react";
import { Themes } from "@/types/theme";
import { useTranslation } from "react-i18next";

type propsType = {
  onClick: () => Promise<void>;
  disable?: boolean;
};
export function WalletConnect({ onClick, disable }: propsType) {
  const { t } = useTranslation(["wallet"]);

  return (
    <Button
      size="lg"
      theme={Themes.white}
      disabled={disable}
      className="mt-8 mb-4 w-full justify-start rounded-md p-8 text-black"
      onClick={async () => {
        await onClick();
      }}
    >
      <div className="flex">
        <div className="flex flex-col justify-center truncate">
          {t("kypay.modal_add_wallet.label.button_wallet_connect")}
        </div>
        <img
          className="ml-8 hidden w-32 sm:block"
          alt=""
          src="/images/olkypass/metamaskIcon.png"
        />
      </div>
    </Button>
  );
}

export default WalletConnect;
